import { lazy, Suspense, type ReactNode } from 'react'

import { MorningLanding } from '@/components/morning-landing'

const BlogIndexPage = lazy(() =>
  import('@/components/blog-index-page').then((m) => ({
    default: m.BlogIndexPage,
  })),
)
const BlogPostRoute = lazy(() =>
  import('@/components/blog-post-route').then((m) => ({
    default: m.BlogPostRoute,
  })),
)
const NotFoundPage = lazy(() =>
  import('@/components/not-found-page').then((m) => ({
    default: m.NotFoundPage,
  })),
)
const PrivacyPage = lazy(() =>
  import('@/components/privacy-page').then((m) => ({
    default: m.PrivacyPage,
  })),
)
const TermsPage = lazy(() =>
  import('@/components/terms-page').then((m) => ({
    default: m.TermsPage,
  })),
)
const MinimalGraphicsPage = lazy(() =>
  import('@/working/minimal-graphics-page').then((m) => ({
    default: m.MinimalGraphicsPage,
  })),
)
const OptimisedHomePage = lazy(() =>
  import('@/components/optimised-home-page').then((m) => ({
    default: m.OptimisedHomePage,
  })),
)
const ProcessGraphicsPage = lazy(() =>
  import('@/working/process-graphics-page').then((m) => ({
    default: m.ProcessGraphicsPage,
  })),
)

function RouteFallback() {
  return (
    <div
      className="min-h-svh bg-paper-deep dark:bg-ocean-deep"
      aria-busy="true"
      aria-live="polite"
    />
  )
}

function App() {
  const pathname = window.location.pathname.replace(/\/+$/, '') || '/'

  if (pathname === '/' || pathname === '/contact') {
    return <MorningLanding />
  }

  let page: ReactNode = <NotFoundPage />

  if (pathname === '/terms') {
    page = <TermsPage />
  } else if (pathname === '/privacy-policy' || pathname === '/privacy') {
    page = <PrivacyPage />
  } else if (pathname === '/blog') {
    page = <BlogIndexPage />
  } else {
    const blogMatch = pathname.match(/^\/blog\/([^/]+)$/)
    if (blogMatch) {
      page = <BlogPostRoute slug={blogMatch[1]!} />
    } else if (pathname === '/process-graphics') {
      page = <ProcessGraphicsPage />
    } else if (pathname === '/minimal-graphics') {
      page = <MinimalGraphicsPage />
    } else if (pathname === '/optimised-home') {
      page = <OptimisedHomePage />
    }
  }

  return <Suspense fallback={<RouteFallback />}>{page}</Suspense>
}

export default App
